var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M0.499999 0L6.5 -5.24537e-07L6.5 2L0.499999 2L0.499999 0ZM0.5 12L0.5 10L18.5 10L18.5 12L0.5 12ZM0.499999 5L12.5 5L12.5 7L0.5 7L0.499999 5Z","fill":"currentColor"}})}
var staticRenderFns = []

export { render, staticRenderFns }